import { Button, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import i18next from 'i18next';
import Sidebar from './components/Sidebar';
import { gTagTracking, serviceDown, trackEvent } from './utils/UtilityFunctions';
import { postApi } from './api/services';
import MainLoader from './components/MainLoader';
import { useSelector } from 'react-redux';

const UserPrescription = () => {

  const location = useLocation()
  const navigate = useNavigate()
  const [prescriptionData, setPrescriptionData] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  const locale = useSelector((state) => state.language.langData)
  
  useEffect(() => {
    // if(!location?.state?.prescription){
    //   // logEvent('fail', 'prescription not found')
    // } else {
    //   // setPrescriptionData(location.state.prescription)
    //   getPrescriptionImage()
    //   // logEvent('success')
    // }
    if(location.state.prescription.prescription_number) {
      getPrescriptionImage()
    } else {
      navigate('/reports')
    }
  }, [])

  const getPrescriptionImage = async () => {
    try {
      setIsLoading(true)
      let params = {
        slipid: location.state.prescription.prescription_number
      }
      console.log("get_prescriptions_by_slipid params", params);
      let res = await postApi('get_prescriptions_by_slipid', params)
      console.log("get_prescriptions_by_slipid res", res);
      if(res?.error) {
        setIsLoading(false)
        serviceDown()
        logEvent('fail', 'prescription not found')
      } else {
        setIsLoading(false)
        setPrescriptionData(res?.prescriptions[0])
        logEvent('success')
      }
    } catch (err) {
      console.log("err", err);
      setIsLoading(false)
      serviceDown()
      logEvent('fail', 'prescription not found')
    } 
  }

  const logEvent = async (status, err) => {
    try {
      await trackEvent('prescription_viewed', status, err ? err : " ", localStorage.getItem('phno'))
      await gTagTracking('prescription_viewed', {
        action: status,
        error: err ? err : " ",
        mobile_number: localStorage.getItem('phno')
      })
    } catch (err) {
      console.log("err", err); 
    }
  }

  const proceedToNxt = async (e) => {
    await trackEvent('explored_treatment', 'success', "", localStorage.getItem('phno'))
    await gTagTracking('explored_treatment', {
      action: 'success',
      error: '',
      mobile_number: localStorage.getItem('phno')
    })
    // let urlParams = encryptPhoneNum(`userid=${localStorage.getItem('user_id')}&prescription=${location.state.prescription.prescription_number}`)
    // let encrypted = encryptPhoneNum(localStorage.getItem('user_id'))
    // let encryptedPrescriptionNum = encryptPhoneNum(location.state.prescription.prescription_number)
    // let url = `https://centabiolab.com/checkout/?add-to-cart=64&userid=${encrypted}&prescription=${encryptedPrescriptionNum}`;
    // let subUrl = JSON.parse(sessionStorage.getItem('checkUser'))?.user_id?.woocommerce_customer_id ? "https://centabiolab.com/my-account/" : "https://centabiolab.com/register/"
    // let url = `${subUrl}?${urlParams}`;
    let url = `https://centabiolab.com/`;
    window.open(url, "_blank");
  }

  const encryptPhoneNum = (phone) => {
    return btoa(encodeURIComponent(phone))
  }
  
  return (
    <>
      {isLoading && <MainLoader/>}
      <div className="photo-container main-section-container prescription-page">
        <Grid
          container
          spacing={0}
          className="d-flex justify-content-start align-items-center"
        >
          <Grid item xs={1} className="">
            <div className="d-flex justify-content-start align-items-center">
              <span
                className="backButtonDiv"
                onClick={() => navigate(-1)}
              >
                <ArrowBackOutlinedIcon className="arrowBackBtn"></ArrowBackOutlinedIcon>
              </span>
            </div>
          </Grid>
          <Grid
            item
            xs={10}
            className="d-flex justify-content-center align-items-center reportPageHead"
          >
            <Typography variant="h6" className="title ml-0px">
              {i18next.t("Prescription")}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Sidebar />
          </Grid>
        </Grid>
        {
          Object.keys(prescriptionData).length > 0 && prescriptionData?.patient_prescription ?
            <div className='userprescriptionpage d-flex justify-content-center align-items-center flex-direction-column'>
              <img className='mb-20px' src={`data:image/jpeg;base64,${prescriptionData?.patient_prescription}`}/> 
              <Button 
                className='commonButton'
                onClick={() => proceedToNxt()}
              >
                {i18next.t(
                  locale === 'en' ?
                    "Access Prescription - Only Treatment" :
                  locale === 'fr' ?
                    "Accéder au traitement sur prescription médicale " :
                  locale === 'es' ?
                    "Acceder al tratamiento con prescripción médica " :
                  "Access Prescription - Only Treatment"
                )}
              </Button>
            </div>
              : 
            <div className="nodatadiv">
              <Typography className="">
                {i18next.t("No prescription found")}
              </Typography>
            </div>
        }
      </div>
    </>
  )
}

export default UserPrescription